import React from "react";
import PropTypes from "prop-types";
import SyntaxHighlighter, {
  registerLanguage
} from "react-syntax-highlighter/light";
import js from "react-syntax-highlighter/languages/hljs/javascript";
import atomOneDark from "react-syntax-highlighter/styles/hljs/atom-one-dark";
import Tabs from "antd/lib/tabs";
import File from "./File.js";
const TabPane = Tabs.TabPane;
registerLanguage("javascript", js);

const Code = props => {
  return (
    <Tabs 
      defaultActiveKey="1"
      style={{marginBottom: "20px"}}
    >
      <TabPane tab={<span>JavaScript</span>} key="1">
        <File filename={props.filename} icon={props.icon}/>
        <SyntaxHighlighter
          showLineNumbers
          language="javascript"
          style={atomOneDark}
          customStyle={{fontSize: "8pt"}}
        >
          {props.jsString}
        </SyntaxHighlighter>
      </TabPane>
    </Tabs>
  );
};

Code.propTypes = {
  jsString: PropTypes.string
};

export default Code;



// WEBPACK FOOTER //
// ./src/steps/Code.js